module.exports = __webpack_public_path__ + "static/img/06.de5cd0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/06.jpg
// module id = 413
// module chunks = 1